export const FACEBOOK_INTEGRATION_URL = '/integrations/facebookIntegration';

export const CLIENT_ID = '186639541875772';
const REDIRECT_URI = 'https://www.app.iterable.com/integrations/selectAdAccounts';
export const FACEBOOK_REDIRECT_URL = `https://www.facebook.com/v14.0/dialog/oauth?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&scope=ads_management,business_management&response_type=code`;
